var map = {
	"./img_my_identify_0.jpg": "6829",
	"./img_my_identify_1.jpg": "0e6d",
	"./img_my_identify_2.jpg": "f68c",
	"./img_my_identify_3.jpg": "64d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d0a6";